import React, { useContext, useEffect, useState } from "react";
import useDeviceType from "Utils/useDeviceType";
import ExerciseMobile from "./components/ExerciseMobile";
import ExercisePC from "./components/ExercisePC";
import { useHistory, useParams } from "react-router-dom";
import { errorMessage } from "../../../Utils/useRequest";
import {
    ExerciseProps,
    getPaper,
    PaperProps,
    questionSubmit,
    saveOne
} from "../../../API/exercise";
import { CourseContext, ExerciseContext, exerciseItem } from "../Store";
import { message, Modal } from "antd";
import { ResultMessage } from "../../../components/ResultMessage";
import ExerciseTopicsHeader from "./components/ExercisePC/components/ExerciseTopicsHeader";
import ExerciseTopicsButtons from "./components/ExerciseMobile/components/ExerciseTopicButtons";

export default function ExerciseTopics() {
    const history = useHistory();
    const { isPC } = useDeviceType();
    const { course } = useContext(CourseContext);
    const { exerciseId } = useParams<{ exerciseId: string }>();
    const [data, setData] = useState<PaperProps>();
    const [headerData, setHeaderData] = useState<ExerciseProps>();
    const [exercise, setExercise] = useState<exerciseItem[]>([]);
    const [showExerciseBar, setShowExerciseBar] = useState(false); //手机端答题卡显示隐藏
    const [stop, setStop] = useState<number | null | undefined>(5000); //每5s检测练习状态

    useEffect(() => {
        getPaperData();
    }, []);

    // ----------初始化处理context中exercise的缓存值start(queTypeId,1单选，2判断，3多选，4主关，5填空，>=6阅读理解，自定义)---------
    useEffect(() => {
        if (!data) return;
        if (data.topics.length !== 0) {
            let list = data.topics;
            let array: exerciseItem[] = [];
            list.forEach(item => {
                if (
                    item.queTypeId.toString() === "1" ||
                    item.queTypeId.toString() === "3" ||
                    item.queTypeId.toString() === "4"
                ) {
                    array.push({
                        id: item.id,
                        isAnswer: item.stuAns ? true : false,
                        oneAnswer: item.stuAns ? item.stuAns : ""
                    });
                } else if (
                    item.queTypeId.toString() === "2" ||
                    item.queTypeId.toString() === "5"
                ) {
                    if (item.stuAns) {
                        let answer = JSON.parse(item.stuAns);
                        if (answer instanceof Array) {
                            //有答案且为多选题，答案array格式
                            array.push({
                                id: item.id,
                                isAnswer: answer.length > 0 ? true : false,
                                moreAnswer: JSON.parse(item.stuAns)
                            });
                        } else {
                            //有答案且为填空题，答案object格式
                            let isBoolean = true;
                            for (let key in answer) {
                                if (answer[key]) {
                                    isBoolean = true;
                                } else {
                                    isBoolean = false;
                                    break;
                                }
                            }
                            array.push({
                                id: item.id,
                                isAnswer: isBoolean,
                                moreAnswer: JSON.parse(item.stuAns)
                            });
                        }
                    } else {
                        array.push({
                            id: item.id,
                            isAnswer: false,
                            moreAnswer: null
                        });
                    }
                } else if (parseInt(item.queTypeId) >= 6) {
                    let subList = item.questions;
                    subList.forEach(subItem => {
                        if (
                            subItem.queTypeId.toString() === "1" ||
                            subItem.queTypeId.toString() === "3" ||
                            subItem.queTypeId.toString() === "4"
                        ) {
                            array.push({
                                id: subItem.id,
                                isAnswer: subItem.stuAns ? true : false,
                                oneAnswer: subItem.stuAns ? subItem.stuAns : ""
                            });
                        } else if (
                            subItem.queTypeId.toString() === "2" ||
                            subItem.queTypeId.toString() === "5"
                        ) {
                            if (subItem.stuAns) {
                                let answer = JSON.parse(subItem.stuAns);
                                if (answer instanceof Array) {
                                    //有答案且为多选题，答案array格式
                                    array.push({
                                        id: subItem.id,
                                        isAnswer:
                                            answer.length > 0 ? true : false,
                                        moreAnswer: JSON.parse(subItem.stuAns)
                                    });
                                } else {
                                    //有答案且为填空题，答案object格式
                                    let isBoolean = true;
                                    for (let key in answer) {
                                        if (answer[key]) {
                                            isBoolean = true;
                                        } else {
                                            isBoolean = false;
                                            break;
                                        }
                                    }
                                    array.push({
                                        id: subItem.id,
                                        isAnswer: isBoolean,
                                        moreAnswer: JSON.parse(subItem.stuAns)
                                    });
                                }
                            } else {
                                array.push({
                                    id: subItem.id,
                                    isAnswer: false,
                                    moreAnswer: null
                                });
                            }
                        }
                    });
                }
            });
            setExercise(array);
        }
    }, [data]);
    // ----------初始化处理context中exercise的缓存值end---------

    async function getPaperData() {
        try {
            let data = await getPaper(exerciseId);
            setData(data);
        } catch (e) {}
    }

    function oneChange(questionId: string, value: any) {
        let array = exercise;
        array.forEach(item => {
            if (item.id == questionId) {
                item.oneAnswer = value;
                item.isAnswer = value ? true : false;
            }
        });
        setExercise(array);
    }

    function moreChange(questionId: string, value: any) {
        let array = exercise;
        array.forEach(item => {
            if (item.id == questionId) {
                item.moreAnswer = value;

                if (value instanceof Array) {
                    //value为数组是多选题
                    value.length > 0
                        ? (item.isAnswer = true)
                        : (item.isAnswer = false);
                } else {
                    //value为object为填空题
                    for (let key in value) {
                        if (value[key]) {
                            item.isAnswer = true;
                        } else {
                            item.isAnswer = false;
                            break;
                        }
                    }
                }
            }
        });

        setExercise(array);
    }

    async function oneSave(questionId: string, value: string) {
        //1单选，3判断,4主观保存
        try {
            await saveOne(exerciseId, questionId, value);
            oneChange(questionId, value); //改变context里缓存的值
        } catch (e) {
            message.error(errorMessage(e));
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }

    async function moreSave(questionId: string, value: any) {
        //2多选，5填空
        try {
            await saveOne(exerciseId, questionId, JSON.stringify(value));
            moreChange(questionId, value); //改变context里缓存的值
        } catch (e) {
            message.error(errorMessage(e));
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }

    // -------------提交操作start--------------
    async function onSubmit(showConfirm: boolean = true) {
        let number = 0;
        data?.topics.map(dataItem => {
            let id = dataItem.id;
            if ("questions" in dataItem) {
                //只有阅读理解和自定义题型有questions小题
                for (let key in dataItem.questions) {
                    for (let exKey in exercise) {
                        //跟context对比如果答题中有一道小题没答都算是这道大题没答
                        if (
                            exercise[exKey].id === dataItem.questions[key].id &&
                            !exercise[exKey].isAnswer
                        ) {
                            number++;
                            return;
                        }
                    }
                }
            } else {
                exercise.map(item => {
                    if (id === item.id && !item.isAnswer) {
                        number++;
                    }
                });
            }
        });

        // 不显示确认信息
        if (!showConfirm) {
            await submit();
            return { number };
        }

        Modal.confirm({
            title: `确认提交练习？`,
            content: `${
                number > 0 ? `还有${number}道题尚未作答，` : ""
            }确认提交后不可修改作答内容，确认要提交练习？`,
            okText: "提交",
            cancelText: "继续作答",
            onOk: () => submit()
        });
    }

    async function submit() {
        //调提交接口
        let paperAnswer: any = [];
        exercise.map(item => {
            if ("oneAnswer" in item) {
                paperAnswer.push({
                    [item.id]: item.oneAnswer
                });
            }
            if ("moreAnswer" in item) {
                paperAnswer.push({
                    [item.id]: item.moreAnswer
                });
            }
        });

        try {
            await questionSubmit(
                course.courseId,
                exerciseId,
                JSON.stringify(paperAnswer)
            );
            ResultMessage.success("提交成功！");
            history.goBack();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function barShow() {
        setShowExerciseBar(true);
    }

    function exerciseBarClose() {
        setShowExerciseBar(false);
    }

    return (
        <div>
            <ExerciseContext.Provider value={{ exercise }}>
                {isPC && (
                    <ExercisePC
                        data={data}
                        oneChange={oneChange}
                        moreChange={moreChange}
                        oneSave={oneSave}
                        moreSave={moreSave}
                        headerDom={
                            <ExerciseTopicsHeader
                                onSubmit={onSubmit}
                                exerciseId={exerciseId}
                            />
                        }
                    />
                )}

                {!isPC && (
                    <ExerciseMobile
                        data={data}
                        oneChange={oneChange}
                        moreChange={moreChange}
                        oneSave={oneSave}
                        moreSave={moreSave}
                        headerDom={
                            <ExerciseTopicsButtons
                                data={data}
                                barShow={barShow}
                                exerciseId={exerciseId}
                            />
                        }
                        onSubmit={onSubmit}
                        showExerciseBar={showExerciseBar}
                        exerciseBarClose={exerciseBarClose}
                    />
                )}
            </ExerciseContext.Provider>
        </div>
    );
}
